import axiosInstant from "../../../../api";
import { uploadRequestEndpoint } from "../../../../api/endpoints";

export interface UploadTranscriptFileOpts {
    /** s3_files id of the video the transcript belongs to. */
    fileId: number;
    /** S3 object key the transcript was read from (no bucket, no leading slash). */
    key: string;
    /** File content as a UTF-8 string. */
    content: string;
    /** Subtitle format; the API fixes the content type from it. */
    format: "srt" | "vtt";
}

// The API accepts only the file's known transcript locations for `key` and
// signs the PUT in the video's own bucket.
export const uploadTranscriptFile = async ({
    fileId,
    key,
    content,
    format
}: UploadTranscriptFileOpts): Promise<void> => {
    const { data } = await axiosInstant.post(uploadRequestEndpoint(), {
        purpose: "transcript",
        fileId,
        format,
        key
    });

    const res = await fetch(data.signedRequest, {
        method: "PUT",
        body: content,
        headers: data.headers
    });

    if (!res.ok) {
        throw new Error(`Upload failed (${format}): ${res.status} ${res.statusText}`);
    }
};
